import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { authActions } from "../../store/auth";
import Autoresponder from "./autoresponder/Autoresponder";
import WebPush from "./pages/WebPush";
import VideoCredits from "./pages/VideoCredits";
import Smtp from "./pages/Smtp";
import "./custom.styles.css";

const ApiSetting = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <a href="#0">Dashboard</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Settings
              </li>
            </ol>
          </nav>

          <h3 className="mb-4">Settings</h3>
          <div className="row">
            <VideoCredits />
            <WebPush />
            <Smtp />

            <Autoresponder />
          </div>
        </div>
      </section>
    </>
  );
};

export default ApiSetting;
